import { getApiKey } from "../../../utils/apiKey";
import React, { useEffect, useState } from "react";
import Header from "../../header";
import { apiCall_domain } from "../../api";
import axios from "axios";
import Spinner from "../../Spinner/Spinner";
import { useHistory } from "routerCompat";
import PulseLoader from "react-spinners/PulseLoader";
import { toast } from "react-hot-toast";
import { useParams } from "react-router-dom";

export const HistroyDetail = () => {
  const history = useHistory();
  const { orderId, type } = useParams();

  let id = orderId;
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [cancelLoader, setCancelLoader] = useState(false);
  useEffect(() => {
    setLoading(true);
    const headers = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };
    axios
      .get(`${apiCall_domain}/customer/mechanics/orders?status=${type}`, {
        headers,
      })
      .then((res) => {
        let specificData = res.data.data.filter((item) => item.id == id);
        setData(...specificData);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);
  const cancelService = () => {
    const headers = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };
    const data = {
      id,
      is_request: false,
    };
    setCancelLoader(true);
    axios
      .post(`${apiCall_domain}/customer/mechanics/requests/cancel`, data, {
        headers,
      })
      .then((res) => {
        toast.success("سرویس مورد نظر لغو شد");
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      })
      .finally(() => {
        setCancelLoader(false);
      });
  };
  return loading ? (
    <Spinner />
  ) : (
    <>
      <Header showSearchBar={true} title={`جزئیات سفارش ${data?.id}#`} />
      <div className="serviceHistoryItemWrapper">
        <div className="historyContainer">
          <div className="historyHeader">
            <div>
              <span className="name">{data?.garage?.name}</span>
              <span className="type">
                {data?.garage.status === "both"
                  ? "خدمات ثابت و سیار"
                  : data?.garage.status === "static"
                    ? "خدمات ثابت"
                    : "خدمات سیار"}
              </span>
            </div>
            <span
              className={`status ${
                type === "active" ? "activeStatus" : "archiveStatus"
              }`}
            >
              {data?.status}
            </span>
          </div>
          <div className="orderHistoryBody">
            <div className="orderHistoryProps">
              <span>
                <img src="/public/assets/services/marker.svg" />
                {data?.address}{" "}
              </span>
              <span>
                <img src="/public/assets/services/clock.svg" />
                {data?.date}
              </span>
              {data?.final_price ? (
                <span>
                  <img src="/public/assets/services/coinbag.svg" />
                  {data?.final_price}
                </span>
              ) : (
                ""
              )}
            </div>
            {data?.problems?.length !== 0 && data?.probelms ? (
              <div>
                <span className="reportedProblems">مشکلات گزارش شده</span>
                {data?.probelms?.map((problem) => (
                  <div className="reportedProblem">
                    <span>نوع خدمت: </span>
                    <span>نوع خودرو:</span>
                    <span>توضیحات:</span>
                  </div>
                ))}
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        {data?.services?.length !== 0 && data?.services ? (
          <div className="serviceHistoryInfo">
            <div>
              <span className="title">خدمات ارائه داده شده</span>
              {data?.services?.length !== 0 ? (
                <>
                  {data?.services?.map((service) => (
                    <div className="historySection">
                      <span>{service.title}</span>
                      <span>
                        {(+service.emergency_min_price).toLocaleString()} تومان
                      </span>
                    </div>
                  ))}
                </>
              ) : (
                <></>
              )}
            </div>
            {data?.consumer_items?.length !== 0 && data?.consumer_items ? (
              <div>
                <span className="title">اقلام مصرف شده</span>
                {data?.consumer_items?.map((item) => (
                  <div className="historySection">
                    <span>{item?.title}</span>
                    <span>
                      {item?.price === null
                        ? " 0 "
                        : item.price.toLocaleString()}
                      تومان
                    </span>
                  </div>
                ))}
              </div>
            ) : (
              ""
            )}

            <div>
              <span className="title">گزارش کار تعمیرکار</span>
              <div>{data?.description}</div>
            </div>
            {/* <div>
              <span className="title">عکس فاکتور</span>
              <div className="showImg">Factor</div>
            </div> */}
            {/* <div>
              <span className="title">عکس بیشتر</span>
              <div className="showImg">Pictire</div>
            </div> */}
          </div>
        ) : (
          <></>
        )}
        {data?.status === "waiting_for_customer" ? (
          <div className="cancelServiceBtn" onClick={cancelService}>
            {cancelLoader ? <PulseLoader color="#fff" /> : "لغو سفارش"}
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
};
